export default function AccountProfileController(
    user, // resolved
    $scope,
    siteService,
    Scroll,
    $timeout
) {
    $scope.user = user;

    $scope.siteService = siteService;

    $scope.activeNav = "profile";

    $timeout(() => {
        Scroll.to("title-focus", siteService.headerHeight + 15);
    }, 500);
}
